import { LiatActivationFormComponent } from './liat-activation-form/liat-activation-form.component';
import { KeyGenerationModalComponent } from './modals/key-generation-modal/key-generation-modal.component';
import { PrintRegistrationKeyComponent } from './liat-activation-form/print-registration-key/print-registration-key.component';

export const allComponents: any[] = [LiatActivationFormComponent, PrintRegistrationKeyComponent, KeyGenerationModalComponent];


export * from './liat-activation-form/liat-activation-form.component';
export * from './liat-activation-form/print-registration-key/print-registration-key.component';
export * from './modals/key-generation-modal/key-generation-modal.component';